//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from '@/views/stencil/components/title'
import  List  from '@/views/stencil/components/list'
import  Editor  from '@/views/stencil/components/editor'
import { InsurStore } from '../../store'


    export default {
        name:'InDetails',
        data() {
            return {
                show:false,
            }
        },
        components: {
            InTitle,
            List,
            Editor,
        },
        computed: {
            questionList() {
                return InsurStore.insurance && Array.isArray(InsurStore.insurance.questionList) ? InsurStore.insurance.questionList : []
            },
            // 格式化数据
            resetList() {
                let list = []
                if(typeof this.questionList == 'object' && this.questionList.length){
                    this.questionList.forEach((element,index) => {
                        if(index - 5 < 0 ){   //只展示5条
                            element.setTitle = element.question
                            element.setContent = element.answer
                            list.push(element)
                        }
                        
                    });
                }
                return list
                
            },
        },
        created() {
        },
        methods: {
            details(){
                this.STATISTICS_CONFIG.insur_proinfo_problems_click()
                this.show = true;
            },
        }
    }
